import { createFileRoute } from '@tanstack/react-router';
import EnquiryConfirmationPage from '../pages/EnquiryConfirmationPage';

export const Route = createFileRoute('/enquiry-confirmation')({
    validateSearch: (search) => ({
        ref: typeof search.ref === 'string' ? search.ref : '',
    }),
    // Server-rendered — see routes/index.jsx for why this replaces Helmet.
    // Personal, ref-specific page — noindex, and not worth a destination
    // fetch of its own just for the title.
    head: () => ({
        meta: [
            { title: 'Enquiry Received | Wilderness Bookings' },
            { name: 'robots', content: 'noindex' },
        ],
    }),
    component: EnquiryConfirmationPage,
});
